/* @flow weak */
import React, { Component, PropTypes } from 'react';
import Avatar from 'components/Avatar.jsx';
import Text from 'components/Text.jsx';
import User from 'entities/RelatedUserSummary';

import 'payments/components/styles/TableRowUserName.scss';

export default class TableRowUserName extends Component {
  static propTypes = {
    user: PropTypes.instanceOf(User),
  };

  static defaultProps = {
    user: null,
  };

  render() {
    const { user } = this.props;

    return (
      <div className="TableRowUserName">
        <Avatar
          className="TableRowUserName-droplet"
          text={user ? user.getInitials() : '?'}
          colorHex={user ? user.getColor() : 'ffffff'}
          color={!user || !user.getColor() ? 'fullGrey' : null}
          size="small"
        />
        <div className="TableRowUserName-name">
          <Text className="TableRowUserName-text" color="pitch">
            {user ? user.getDisplayName() : '-'}
          </Text>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/TableRowUserName.jsx